(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("howler"), require("pako"));
	else if(typeof define === 'function' && define.amd)
		define(["howler", "pako"], factory);
	else if(typeof exports === 'object')
		exports["openfl"] = factory(require("howler"), require("pako"));
	else
		root["openfl"] = factory(root["window"], root["pako"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__31771__, __WEBPACK_EXTERNAL_MODULE__39960__) => {
return 